import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ViaSurveyBeforeProgramComponent } from './viaSurveyBeforeProgram.component';
import { Shell } from '@app/shell/shell.service';
import { getRoutePath, PlRoute } from '@app/utils/routes';

const routes: Routes = [
  Shell.childRoutes(
    [
      {
        path: `${getRoutePath(PlRoute.viaSurvey, false)}`,
        component: ViaSurveyBeforeProgramComponent,
        data: { hideMenu: true, hideProfileSection: true, disableLinkOnPlLogo: true },
      },
    ],
    false,
  ),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class ViaSurveyBeforeProgramRoutingModule {}
